import { Component, Input } from '@angular/core';

@Component({
  selector: 'ifc-id-verse-header',
  templateUrl: './id-verse-header.component.html',
  styleUrls: ['./id-verse-header.component.scss'],
  standalone: false
})
export class IdVerseHeaderComponent {
  @Input() logoUrl: string;
}
